module.exports = __webpack_public_path__ + "static/careProblems-783ec29e32c6d4a08983f8c573fe3740.svg";